import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgApiFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17.243 12.531-2.65 2.649a.74.74 0 0 1-.53.22.749.749 0 0 1-.53-1.28l2.119-2.119-2.119-2.119a.75.75 0 0 1 1.06-1.061l2.65 2.649a.75.75 0 0 1 0 1.061m-6.775 1.589a.749.749 0 1 1-1.06 1.06l-2.649-2.649a.75.75 0 0 1 0-1.061l2.649-2.649a.749.749 0 1 1 1.06 1.061l-2.119 2.119zm5.75-11.62H7.783C4.623 2.5 2.5 4.72 2.5 8.026v7.947c0 3.306 2.123 5.527 5.283 5.527h8.434c3.16 0 5.283-2.221 5.283-5.527V8.026c0-3.306-2.123-5.526-5.282-5.526"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgApiFilled);
export default ForwardRef;
